import React from 'react'
import { AppLegendChips } from "@components"
import { dsColorNew } from "@palette"


// Under the table, as its footer: what the cell colours mean is read after the cells, not before
export default function AnalyzersLegendToolbar({ isRating = false }) {
    const text = isRating ? "Rating" : "Price"

    return <AppLegendChips
        variant="plain"
        sx={{ justifyContent: 'flex-start', mt: 1.5 }}
        groups={[[
            { icon: "droplet", label: `Cheapest ${text} in column`, color: dsColorNew.successBar },
            { icon: "droplet", label: `Most Expensive ${text} in column`, color: dsColorNew.dangerSoft },
        ]]}
    />
}
